export default function isIosSafari() {
	var ua = window.navigator.userAgent
	var iOS = !!ua.match(/iP(ad|od|hone)/i)
	var webkit = !!ua.match(/WebKit/i)
	return iOS && webkit && !ua.match(/CriOS|FxiOS|OPiOS|mercury/i)
	// CriOS	: Chrome
	// FxiOS	: ?
	// OPiOS	: Opera
	// mercury	: ?
}